import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { contentCountsRequest } from '~src/spacesPlatform/actions/ContentCountsActions';
import { selectContentCounts, selectContentCountsUpToDate } from '~src/spacesPlatform/selectors/ContentCountsSelector';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { siteUrlsSelector } from '../../bootstrap/redux/selectors/SiteUrlsSelectors';
import { AppState } from '../../bootstrap/redux/state/AppState';
import { selectCatalogingOnSiteEnabled } from '../../catalog/selectors/CatalogSelectors';
import { LensSpace, LensSpaceDispatchProps, LensSpaceStateProps } from './LensSpace';

const mapStateToProps: MapStateToProps<LensSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  urls: siteUrlsSelector(state),
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state),
  contentCounts: selectContentCounts<'lens'>(state, 'lens'),
  contentCountsUpToDate: selectContentCountsUpToDate(state),
  siteUrlName: SessionSiteSelectors.siteUrlName(state),
});

const mapDispatchToProps: MapDispatchToProps<LensSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest,
  },
  dispatch);

export const ConnectedLensSpace = connect(mapStateToProps, mapDispatchToProps)(LensSpace);
